import { openBlock as t, createElementBlock as o, createElementVNode as r } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function l(s, e) {
  return t(), o("svg", n, [...e[0] || (e[0] = [
    r("path", {
      stroke: "currentColor",
      "stroke-width": "2",
      d: "M12 8.465h10M16.5 13 12 8.5l2.83-2.83L16.5 4M12 15.5H2m5.5-4.535 4.5 4.5-2.829 2.828L7.5 19.965"
    }, null, -1)
  ])]);
}
const c = { render: l };
export {
  c as default,
  l as render
};
